<h3 class="report-title" style="margin-bottom: 16px">SUMMARY</h3>
<!-- Compare 2 Weeks -->
<div class="flex-row-group" style="margin-bottom: 24px;">
  <!-- Avg Score of the week -->
  <div class="report-card--col-6" style="margin-right: 16px;">
    <h3 class="header">Average Score of the Week</h3>
    <h1 class="value">
      <awair-index-dot
        style="padding-bottom: 12px; margin-right: 16px;"
        [color]="scoreCondition"
        [width]="20"
        [height]="20">
      </awair-index-dot>
      {{scoreWeeklyAvg.value | number: '1.0-1'}}
    </h1>
  </div>
  <!-- /.Avg Score of the week -->
  <!-- Increase/Decrease Percentage -->
  <div class="report-card--col-6">
    <h3 class="header" style="margin-bottom: 8px;">Compared to the previous week, your score 
      <span style="font-weight: bold;" *ngIf="isScoreIncreased">increased</span>
      <span style="font-weight: bold;" *ngIf="!isScoreIncreased">decreased</span>
    by</h3>
    <h1 class="value" [style.color]="scoreWeeklyAvg.percentage === 'No Data' ? '#CDD3D8' : '#495056'">{{scoreWeeklyAvg.percentage}}</h1>
  </div>
  <!-- /.Increase/Decrease Percentage -->
</div>
<!-- /.Compare 2 Weeks -->

<!-- Weekly Average -->
<div class="report-card--col-12" style="margin-bottom: 24px;">
  <header style="padding: 16px 24px;">
    <h3 class="header" style="margin-bottom: 8px;">Weekly Average</h3>
    <h4 class="sub-header">Your {{worstFactor | sensorHeader}} 
      <span *ngIf="worstFactor === 'voc'">have</span>
      <span *ngIf="worstFactor !== 'voc'">has</span>
      the most room for improvement.</h4>
  </header>
  <div class="report-card-divider--horizontal"></div>
  <section style="position: relative; display: flex">
    <!-- Report Card Content -->
    <awair-report-card-content
      *ngFor="let weeklyAvg of weeklyAvgList; let i = index"
      style="box-sizing: border-box;"
      [style.border-right]="i === weeklyAvgList.length - 1 ? 'none' : '1px solid #E9ECEE'"
      [width]="'190px'"
      [header]="weeklyAvg.sensorHeader"
      [condition]="weeklyAvg.condition"
      [value]="weeklyAvg.value"
      [unit]="weeklyAvg.unit"
      [percentage]="weeklyAvg.percentage">
    </awair-report-card-content>
    <!-- /.Report Card Content -->
  </section>
</div>
<!-- /.Weekly Average -->

<!-- Daily Average Score -->
<div class="report-card--col-12" style="margin-bottom: 24px;">
  <header style="padding: 16px 24px;">
    <h3 class="header">Daily Average Score</h3>
  </header>
  <div class="report-card-divider--horizontal"></div>
  <section style="position: relative; display: flex">
    <!-- Report Card Content -->
    <awair-report-card-content
      *ngFor="let dailyScoreAvg of dailyScoreAvgList; let i = index"
      style="box-sizing: border-box;"
      [style.border-right]="i === dailyScoreAvgList.length - 1 ? 'none' : '1px solid #E9ECEE'"
      [style.background-color]="i % 2 !== 0 ? '#FBFCFC' : '#FFFFFF'"
      [width]="'136px'"
      [header]="dailyScoreAvg.date"
      [condition]="dailyScoreAvg.condition"
      [value]="dailyScoreAvg.value">
    </awair-report-card-content>
  <!-- /.Report Card Content -->
  </section>
</div>
<!-- /.Daily Average Score -->